var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducation24 = function SvgEducation24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.594 4.086a1 1 0 0 1 .812 0l8.98 3.99A1 1 0 0 1 22 9v3a1 1 0 1 1-2 0v-1.461l-1 .444V16.325c0 1.43-.916 2.701-2.273 3.154a14.948 14.948 0 0 1-9.454 0A3.325 3.325 0 0 1 5 16.325V10.983l-2.406-1.07a1 1 0 0 1 0-1.827l9-4Zm.812 9.828L17 11.872v4.453c0 .57-.365 1.076-.906 1.256-2.657.886-5.53.886-8.188 0A1.324 1.324 0 0 1 7 16.325v-4.453l4.594 2.042a1 1 0 0 0 .812 0ZM5.462 9 12 11.906 18.538 9 12 6.094 5.462 9Z",
    fill: "currentColor"
  })));
};
export default SvgEducation24;